import { BaseModel } from '../base-model';

export interface IUserListingModel {
  Id?: number;
  Name?: string;
  ShortName?: string;
  OwnerId?: number;
}
export class UserListingModel extends BaseModel<IUserListingModel> implements IUserListingModel {
  Id?: number;
  Name?: string;
  ShortName?: string;
  /**
   *
   */
  constructor(options?: IUserListingModel) {
    super(options);
  }
}